import { createSlice } from "@reduxjs/toolkit";
import { PICKED_FILES_FROM } from "../constants/UploadFilesConstants";

const initialState = {
    containerImagesArray: [],
};

const imageContainerReducerSlice = createSlice({
    name: "imageContainerReducer",
    initialState,
    reducers: {
        setContainerImagesArray(state, action) {
            state.containerImagesArray = action.payload;
        },
        addContainerImageInArray(state, action) {
            state.containerImagesArray.unshift(action.payload);
        },
        addMultipleContainerImagesInArray(state, action) {
            action.payload.forEach((obj) => {
                const imageName = obj.imageName;
                const locationImage = imageName?.indexOf("location") > -1;
                const imgObj = {
                    thumb: decodeURI(obj.thumbURL),
                    original: obj.image_url,
                    name: imageName,
                    isLocationImage: locationImage,
                    caption: obj.caption,
                    uploadType: PICKED_FILES_FROM.FROM_GALLERY.toString(),
                };
                state.containerImagesArray.unshift(imgObj);
            });
        },
        deleteContainerImageFromArrayByName(state, action) {
            const tempArr = state.containerImagesArray.filter((image) => image.name !== action.payload);
            state.containerImagesArray = tempArr;
        },
        resetImageConatiner() {
            return initialState;
        },
    },
});

export const {
    setContainerImagesArray,
    addContainerImageInArray,
    addMultipleContainerImagesInArray,
    deleteContainerImageFromArrayByName,
    resetImageConatiner,
} = imageContainerReducerSlice.actions;

export default imageContainerReducerSlice.reducer;
